import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../config/site';

const Footer = () => {
  return (
    <footer className="bg-[#0B1F3A] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src={siteConfig.logo.dark}
              alt={siteConfig.shortName}
              className="h-12 w-auto mb-4 object-contain"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              A diversified global operating and investment group building tomorrow&apos;s businesses today.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-[#D4AF37] mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-white/70 hover:text-white text-sm transition-colors">About Us</Link></li>
              <li><Link to="/industries" className="text-white/70 hover:text-white text-sm transition-colors">Industries</Link></li>
              <li><Link to="/leadership" className="text-white/70 hover:text-white text-sm transition-colors">Leadership</Link></li>
              <li><Link to="/corporate-brief" className="text-white/70 hover:text-white text-sm transition-colors">Corporate Brief</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-[#D4AF37] mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/financials" className="text-white/70 hover:text-white text-sm transition-colors">Financials</Link></li>
              <li><Link to="/vision" className="text-white/70 hover:text-white text-sm transition-colors">Vision & Mission</Link></li>
              <li><Link to="/social-impact" className="text-white/70 hover:text-white text-sm transition-colors">Social Impact</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-white text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-[#D4AF37] mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href={`mailto:${siteConfig.emails.legal}`} className="text-white/70 hover:text-white text-sm transition-colors">
                  {siteConfig.emails.legal}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteConfig.emails.business}`} className="text-white/70 hover:text-white text-sm transition-colors">
                  {siteConfig.emails.business}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteConfig.emails.info}`} className="text-white/70 hover:text-white text-sm transition-colors">
                  {siteConfig.emails.info}
                </a>
              </li>
              <li className="text-white/70 text-sm pt-2">Mountain View, CA 94043</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {siteConfig.copyrightYear} {siteConfig.companyName}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
